const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`<figure class="wp-block-table`);
                if ((context.has(`block_style`) ? context.get(`block_style`) : null)) {
                    this.echo(` is-style-`);
                    this.echo(this.env.getFilter('escape').traceableCallable(1, this.source)(...[this.env, (context.has(`block_style`) ? context.get(`block_style`) : null), `html`, null, true]));
                }
                this.echo(`">
  <table`);
                if ((context.has(`fixed_layout`) ? context.get(`fixed_layout`) : null)) {
                    this.echo(` class="has-fixed-layout"`);
                }
                this.echo(`>
    `);
                if ((context.has(`show_header`) ? context.get(`show_header`) : null)) {
                    this.echo(`      <thead>
        <tr>
          `);
                    context.set('_parent', context.clone());

                    (() => {
                        let c = this.ensureTraversable(this.createRange(1, 3));

                        if (c === context) {
                            context.set('_seq', context.clone());
                        }
                        else {
                            context.set('_seq', c);
                        }
                    })();

                    this.iterate(context.get('_seq'), (__key__, __value__) => {
                        context.proxy[`_key`] = __key__;
                        context.proxy[`i`] = __value__;
                        this.echo(`            <th`);
                        if ((context.has(`column_alignment`) ? context.get(`column_alignment`) : null)) {
                            this.echo(` class="has-text-align-`);
                            this.echo(this.env.getFilter('escape').traceableCallable(7, this.source)(...[this.env, (context.has(`column_alignment`) ? context.get(`column_alignment`) : null), `html`, null, true]));
                            this.echo(`" data-align="`);
                            this.echo(this.env.getFilter('escape').traceableCallable(7, this.source)(...[this.env, (context.has(`column_alignment`) ? context.get(`column_alignment`) : null), `html`, null, true]));
                            this.echo(`"`);
                        }
                        this.echo(`>Heading `);
                        this.echo(this.env.getFilter('escape').traceableCallable(7, this.source)(...[this.env, context.get(`i`), `html`, null, true]));
                        this.echo(`</th>
          `);
                    });
                    (() => {
                        let parent = context.get('_parent');
                        context.delete('_seq');
                        context.delete('_iterated');
                        context.delete('_key');
                        context.delete('i');
                        context.delete('_parent');
                        context.delete('loop');
                        for (let [k, v] of parent) {
                            if (!context.has(k)) {
                                context.set(k, v);
                            }
                        }
                    })();
                    this.echo(`        </tr>
      </thead>
    `);
                }
                this.echo(`    <tbody>
      `);
                context.set('_parent', context.clone());

                (() => {
                    let c = this.ensureTraversable(this.createRange(1, 3));

                    if (c === context) {
                        context.set('_seq', context.clone());
                    }
                    else {
                        context.set('_seq', c);
                    }
                })();

                this.iterate(context.get('_seq'), (__key__, __value__) => {
                    context.proxy[`_key`] = __key__;
                    context.proxy[`i`] = __value__;
                    this.echo(`        <tr>
          <td`);
                    if ((context.has(`column_alignment`) ? context.get(`column_alignment`) : null)) {
                        this.echo(` class="has-text-align-`);
                        this.echo(this.env.getFilter('escape').traceableCallable(15, this.source)(...[this.env, (context.has(`column_alignment`) ? context.get(`column_alignment`) : null), `html`, null, true]));
                        this.echo(`" data-align="`);
                        this.echo(this.env.getFilter('escape').traceableCallable(15, this.source)(...[this.env, (context.has(`column_alignment`) ? context.get(`column_alignment`) : null), `html`, null, true]));
                        this.echo(`"`);
                    }
                    this.echo(`>Hello, this is row `);
                    this.echo(this.env.getFilter('escape').traceableCallable(15, this.source)(...[this.env, context.get(`i`), `html`, null, true]));
                    this.echo(`</td>
          <td`);
                    if ((context.has(`column_alignment`) ? context.get(`column_alignment`) : null)) {
                        this.echo(` class="has-text-align-`);
                        this.echo(this.env.getFilter('escape').traceableCallable(16, this.source)(...[this.env, (context.has(`column_alignment`) ? context.get(`column_alignment`) : null), `html`, null, true]));
                        this.echo(`" data-align="`);
                        this.echo(this.env.getFilter('escape').traceableCallable(16, this.source)(...[this.env, (context.has(`column_alignment`) ? context.get(`column_alignment`) : null), `html`, null, true]));
                        this.echo(`"`);
                    }
                    this.echo(`>Content</td>
          <td`);
                    if ((context.has(`column_alignment`) ? context.get(`column_alignment`) : null)) {
                        this.echo(` class="has-text-align-`);
                        this.echo(this.env.getFilter('escape').traceableCallable(17, this.source)(...[this.env, (context.has(`column_alignment`) ? context.get(`column_alignment`) : null), `html`, null, true]));
                        this.echo(`" data-align="`);
                        this.echo(this.env.getFilter('escape').traceableCallable(17, this.source)(...[this.env, (context.has(`column_alignment`) ? context.get(`column_alignment`) : null), `html`, null, true]));
                        this.echo(`"`);
                    }
                    this.echo(`>Content</td>
        </tr>
      `);
                });
                (() => {
                    let parent = context.get('_parent');
                    context.delete('_seq');
                    context.delete('_iterated');
                    context.delete('_key');
                    context.delete('i');
                    context.delete('_parent');
                    context.delete('loop');
                    for (let [k, v] of parent) {
                        if (!context.has(k)) {
                            context.set(k, v);
                        }
                    }
                })();
                this.echo(`    </tbody>
    `);
                if ((context.has(`show_footer`) ? context.get(`show_footer`) : null)) {
                    this.echo(`      <tfoot>
        <tr>
          `);
                    context.set('_parent', context.clone());

                    (() => {
                        let c = this.ensureTraversable(this.createRange(1, 3));

                        if (c === context) {
                            context.set('_seq', context.clone());
                        }
                        else {
                            context.set('_seq', c);
                        }
                    })();

                    this.iterate(context.get('_seq'), (__key__, __value__) => {
                        context.proxy[`_key`] = __key__;
                        context.proxy[`i`] = __value__;
                        this.echo(`            <td`);
                        if ((context.has(`column_alignment`) ? context.get(`column_alignment`) : null)) {
                            this.echo(` class="has-text-align-`);
                            this.echo(this.env.getFilter('escape').traceableCallable(25, this.source)(...[this.env, (context.has(`column_alignment`) ? context.get(`column_alignment`) : null), `html`, null, true]));
                            this.echo(`" data-align="`);
                            this.echo(this.env.getFilter('escape').traceableCallable(25, this.source)(...[this.env, (context.has(`column_alignment`) ? context.get(`column_alignment`) : null), `html`, null, true]));
                            this.echo(`"`);
                        }
                        this.echo(`>Footer `);
                        this.echo(this.env.getFilter('escape').traceableCallable(25, this.source)(...[this.env, context.get(`i`), `html`, null, true]));
                        this.echo(`</td>
          `);
                    });
                    (() => {
                        let parent = context.get('_parent');
                        context.delete('_seq');
                        context.delete('_iterated');
                        context.delete('_key');
                        context.delete('i');
                        context.delete('_parent');
                        context.delete('loop');
                        for (let [k, v] of parent) {
                            if (!context.has(k)) {
                                context.set(k, v);
                            }
                        }
                    })();
                    this.echo(`        </tr>
      </tfoot>
    `);
                }
                this.echo(`  </table>
  `);
                if ((context.has(`show_caption`) ? context.get(`show_caption`) : null)) {
                    this.echo(`    <figcaption>A caption can be added but is not rendered as a caption element</figcaption>
  `);
                }
                this.echo(`</figure>
`);
            }

            getTemplateName() {
                return `f7fd401f97c6ff1e6043edfec48bbdfb3613f98309eee96764d9ec9207eb569c`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `f7fd401f97c6ff1e6043edfec48bbdfb3613f98309eee96764d9ec9207eb569c`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, 'f7fd401f97c6ff1e6043edfec48bbdfb3613f98309eee96764d9ec9207eb569c');

let template = env.loadTemplate('f7fd401f97c6ff1e6043edfec48bbdfb3613f98309eee96764d9ec9207eb569c');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/vendor/wordpress/demo/table.twig", args: context }
     );
     return rendered;;
};